/**
 * The moving colour behind the sign-in screens.
 *
 * Four washes drawn from the gradient QRL fills its own logo with — amber, azure, green,
 * violet — turning slowly as one composition. The idea is borrowed from jmw.nz, a former
 * student's site, where the same trick is done with an animated SVG gradient.
 *
 * There is no state, no canvas and no requestAnimationFrame here on purpose. Everything
 * moves in CSS, which means the compositor does it on another thread and nothing competes
 * with the two things this app actually needs the main thread for: CPython in a Web Worker
 * and Strudel's audio graph. See the notes in styles.css for why it is gradients rather
 * than a shader.
 *
 * `aria-hidden` because it is decoration and says nothing. A screen reader announcing
 * "amber azure green violet" would be worse than silence.
 */
export function Aurora() {
  return (
    <div className="aurora" aria-hidden="true">
      {/* The clip stays still and the square inside it turns. Rotating the clip itself
          puts its own four corners on screen, which is what the first version did. */}
      <div className="aurora-spin">
        <span className="amber" />
        <span className="azure" />
        <span className="green" />
        <span className="violet" />
      </div>
    </div>
  );
}
